export default __webpack_public_path__ + "static/bg-educacao-infantil-81fbabca28dce2521a3136b435a73c1f.svg";